
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Box, Grid2, Stack } from '@mui/material';
import Container from '@mui/material/Container';


export default function Content() {

  const Number = ({ num }) => {
    return (
      <Box sx={{
        background: theme => theme.palette.primary.main, p: 1, borderRadius: '50%', width: '25px', height: '25px', display: 'flex',
        alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1rem', color: 'white'
      }}>
        {num}
      </Box>
    )
  }

  const ListItem = ({ num, text }) => {
    return (
      <Stack direction={'row'} alignItems={'center'} sx={{color:'text.secondary'}}>
        <Number num={num} />
        {text}
      </Stack>
    )
  }
  return (
    <React.Fragment>
      <Container maxWidth="xl" sx={{ my: 5 }}>
        <Grid2 container justifyContent={'space-between'}>
        <Grid2 size={{ xs: 12 }}>
        <Typography variant='h5'>1. Callgoose SQIBS Runner program</Typography>
        <br/>
        </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant='body1'  sx={{color:'text.secondary', fontWeight:600, mb:2}}>How Does Callgoose SQIBS Automation Runner Work?</Typography>
          
            <Stack spacing={2}>
              <ListItem num={1} text={'The alert source (e.g., Prometheus) sends alerts to the Callgoose SQIBS API when a problem occurs.'} />
              <ListItem num={2} text={'Callgoose SQIBS API generates Incidents based on the predefined filter values created by the Callgoose SQIBS user.'} />
              <ListItem num={3} text={'Callgoose SQIBS invokes the automation workflow created by the user.'} />
              <ListItem num={4} text={'The Callgoose SQIBS Automation Runner (cg-automation-runner.jar) that operates on the user side will fetch the details and execute the workflow to resolve the problem.'} />
              <ListItem num={5} text={'After fixing the problem, Callgoose SQIBS Automation Runner will resolve the Incident through an outbound connection to the Callgoose SQIBS server.'} />
              {/* <ListItem num={5} text={<Typography>This demonstrate test link <a href='https://www.callgoose.com'>test link</a></Typography>} /> */}
            </Stack>
          </Grid2>
        </Grid2>
      </Container>
    </React.Fragment>
  );
}
